function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDel20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z",
  "data-name": "Rectangle 118",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Union 16",
  style: {
    fill: "#fff"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "m5.657 6.363-4.95 4.95L0 10.607l4.951-4.95L0 .706.706 0l4.95 4.95L10.607 0l.706.706-4.95 4.95 4.95 4.951-.706.706z",
  style: {
    stroke: "none"
  },
  transform: "translate(4 4.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.607 11.313-4.95-4.95-4.95 4.95L0 10.607l4.95-4.95L0 .706.707 0l4.95 4.95L10.608 0l.706.706-4.95 4.95 4.95 4.951-.706.706z",
  style: {
    fill: "#d9d9d9",
    stroke: "none"
  },
  transform: "translate(4 4.3)"
})));
export default SvgIconDel20;